/**
 * `Automations (read-only)` — phase 71 (config-trainer-brief-cron-display).
 *
 * Surfaces the proactive cron sagas that run for this studio on the
 * `/config/:slug` page so staff/admin can SEE the automation + when it fires,
 * closing the "I can't see the flow" visibility gap. Display-only: the live
 * schedules are global Inngest cron functions — editing nothing here
 * reschedules them (same contract as the Memory section's "Cron schedules"
 * informational block, phase 61).
 *
 * The Trainer Morning Brief (flow T1, saga `trainer_morning_brief`, phase 70)
 * is NOT a simple cron: its Inngest `triggerCron` is hourly (`0 * * * *`),
 * gated inside the step on the studio-local hour ===
 * `TRAINER_MORNING_BRIEF_SEND_HOUR` (6). So we render the EFFECTIVE schedule
 * "Every day at 06:00 — studio-local time", NOT the raw hourly cron (feeding
 * `0 * * * *` through the page's `humanizeCron` would wrongly print
 * "00:00 UTC").
 *
 * The web bundle does not import `@layer/saga-runtime` (it inlines helpers),
 * so the "06:00" hour is HARDCODED here. A saga-runtime unit test pins
 * `TRAINER_MORNING_BRIEF_SEND_HOUR === 6` so a send-hour change fails CI and
 * reminds the editor to update this display string (same spirit as the
 * phase-61 l2-yaml cron-mirror drift guard).
 *
 * This component lives in its own module (importing ONLY the dependency-light
 * `studioTimeZone()` session value) so it can be render-tested in isolation without
 * dragging in the full `/config` page's supabase/api module graph.
 */

import { studioTimeZone } from "../lib/studio-tz";

export function ScheduledJobsSection(): JSX.Element {
  return (
    <fieldset>
      <legend>Automations (read-only)</legend>
      <p className="subtle">
        Proactive cron-driven automations that run for this studio. Display-only
        — the live schedules are global Inngest cron functions; this page does
        not reschedule them.
      </p>
      <div className="form-row">
        <ul
          className="subtle"
          style={{ margin: "0.25rem 0", paddingLeft: "1.2rem" }}
        >
          <li>
            <strong>Trainer Morning Brief</strong> — Every day at 06:00 —
            studio-local time ({studioTimeZone()}). Each trainer with a session
            that day gets a WhatsApp brief of their schedule + per-client notes.
          </li>
        </ul>
        <small className="subtle">
          Display-only. The brief is a global cron saga that fires hourly and
          sends at the studio-local 06:00; editing here does not reschedule it.
        </small>
      </div>
    </fieldset>
  );
}
